import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'CmgRewardsFeatureFlagsOffline',
})
export default class CmgRewardsFeatureFlagsOffline extends Vue {
  get sadAvocado(): string {
    return this.$appStore.state.cms.images.feedback.sadAvocado.default;
  }

  get isRewardsOnline(): boolean {
    return this.$appStore.state.featureFlags.orderingStatus?.isRewardsOnline ?? true;
  }

  get isRewardsExchangeOnline(): boolean {
    return this.$appStore.state.featureFlags.orderingStatus?.isRewardsExchangeOnline ?? true;
  }

  get rewardsOfflineMessage(): string {
    return `We're having trouble with our Rewards ${ !this.isRewardsOnline ? '' : 'Exchange ' }but you can still order, earn points and use existing rewards. Check back later.`;
  }
}